<template>
    <div class="column" style="">
        <el-form style="max-width: 470px;margin: 0 auto;margin-top: 30px;" label-width="auto" label-position="top">
            <el-form-item>
                <span slot="label">
                    Prompt: <span style="color: red;font-size: 11px;">
                        Please replace "Tom Cruise" with your own name</span>
                </span>
                <el-input v-model="store.prompt" style="" :rows="6" type="textarea"
                    placeholder="Please input Prompt, example:'Germon' handwriting signature" />
            </el-form-item>
            <el-form-item label="Models" class="select-model">
                <div :class="{ items: true, active: store.model === 'flux_pro' }" @click="handleModel('quality')">
                    <div class="img square"
                        style="background-image: url(https://remaker.ai/vue/ai-avatar/image/woman-1.jpg);"></div>
                    <div class="text-center" style="text-align: center;"> high quality </div>
                </div>
                <div :class="{ items: true, active: store.model === 'flux_schnell' }" @click="handleModel('fast')">
                    <div class="img square"
                        style="background-image: url(https://remaker.ai/vue/ai-avatar/image/woman-9.jpg);"></div>
                    <div class="text-center" style=" text-align: center;"> fast </div>
                </div>
            </el-form-item>
            <el-form-item> </el-form-item>
            <el-form-item>
                <el-button :disabled="store.prompt.length <= 0" style="width: 100%;" type="primary"
                    @click="onSubmit">Generate</el-button>
            </el-form-item>
        </el-form>
    </div>

</template>
<script name="Draw" setup>
import { ref, reactive, onMounted, nextTick, inject, toRefs, toRaw } from "vue";
import { useStore } from "@/stores"

const store = useStore()

// const state = reactive({
//     prompt: '',
//     model: '',
// })

const handleModel = (value) => {
    if (value === 'fast') {
        store.setModel('flux_schnell')
    } else {
        store.setModel('flux_pro')
    }
}

const onSubmit = () => {
    console.log('submit')
    store.generate()
}
onMounted(() => {
    store.init()
});


</script>
<style scoped>
#videoContainer {
    height: 842px;
    padding-top: 45px;
}

.pen {
    cursor: url("data:image/svg xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24'><path transform='rotate(90, 12, 12)' d=' M20.71, 7.04C20.37, 7.38 20.04, 7.71 20.03, 8.04C20, 8.36 20.34, 8.69 20.66, 9C21.14, 9.5 21.61, 9.95 21.59, 10.44C21.57, 10.93 21.06, 11.44 20.55, 11.94L16.42, 16.08L15, 14.66L19.25, 10.42L18.29, 9.46L16.87, 10.87L13.12, 7.12L16.96, 3.29C17.35, 2.9 18, 2.9 18.37, 3.29L20.71, 5.63C21.1, 6 21.1, 6.65 20.71, 7.04M3, 17.25L12.56, 7.68L16.31, 11.43L6.75, 21H3V17.25Z' /></svg>"), default;

}

:deep(.select-model .el-form-item__content) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
}


.square {
    border: 3px solid inherit;
    border-radius: 8px;
    aspect-ratio: 1 / 1;

    background-size: contain;
}

.items.active .square {
    border: 3px solid #409eff;

}
</style>